import { gls, sls } from '@/utils/storage'
import dayjs from 'dayjs'

export const saveChannelId = (query) => {
  if (query.channel_id) {
    sls('channel_id', {
      value: query.channel_id,
      period: getTodayLastStamp()
    })
  }
  console.log('channelId有效期：', dayjs(getTodayLastStamp()).format('YYYY-MM-DD HH:mm:ss'))
}
export const getChannelId = () => {
  try {
    let data = gls('channel_id')
    if (data && data.period > Date.now()) {
      return data.value
    } else {
      return undefined
    }
  } catch (e) {
    console.log('Failed to get data from storage: ', e)
    return undefined
  }
}
const getTodayLastStamp = () => {
  let now = new Date()
  let endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
  return endOfDay.getTime()
}
